import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { widont } from 'typogr';
import Transition from 'react-transition-group/Transition';
import CoverLogo from './CoverLogo';
import CtaButton from '../CtaButton';


const CoverText = ({ show, duration, title, displayLogo, description, buttons, footerText, onButtonClick }) => {
  const transitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 1 },
    exited: { opacity: 0 },
  };

  const headerClasses = classNames({
    xlong: title.length > 30,
  });

  return (
    <Transition in={show} timeout={0} appear>
      {state => (
        <div className="cover-overlay" style={{ transition: `opacity ${duration}ms linear`, ...transitionStyles[state] }}>
          <div>
            <div className="text-container">
              {displayLogo ? <CoverLogo /> : null}
              <h1 className={headerClasses} dangerouslySetInnerHTML={{ __html: title }} />
              {description ? <div className="cover-overlay-text" dangerouslySetInnerHTML={{ __html: widont(description || '') }} /> : null}
            </div>
            <div className="button-container">
              {buttons.map(({ linkType, titleId, mediaId, ...rest }, i) => {
                const itemId = linkType === 'media' ? mediaId : titleId;
                const handleClick = () => onButtonClick(itemId);
                return <CtaButton key={`button-${i}`} onClick={handleClick} {...rest} />;
              })}
            </div>
            {footerText ? <footer className="text-container" dangerouslySetInnerHTML={{ __html: footerText }} /> : null}
          </div>
        </div>
      )}
    </Transition>
  );
};

CoverText.propTypes = {
  show: PropTypes.bool,
  duration: PropTypes.number,
  displayLogo: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  buttons: PropTypes.array,
  onButtonClick: PropTypes.func,
};

CoverText.defaultProps = {
  onButtonClick: () => {},
  duration: 1000,
};

export default CoverText;



// WEBPACK FOOTER //
// ./src/components/Covers/CoverText.js